import { apiFetch } from "../api.js";
import type {
  CreateDafAccountInput,
  CreateDonationInput,
  DafAccount,
  DafAccountsListResponse,
  Donation,
  DonationsListResponse,
} from "./types.js";

export interface ListDonationsArgs {
  readonly from?: string;
  readonly to?: string;
  readonly taxYear?: number;
  readonly includeArchived?: boolean;
}

export function listDonations(
  args: ListDonationsArgs = {},
): Promise<DonationsListResponse> {
  const qs = new URLSearchParams();
  if (args.from) qs.set("from", args.from);
  if (args.to) qs.set("to", args.to);
  if (args.taxYear !== undefined) qs.set("tax_year", String(args.taxYear));
  if (args.includeArchived) qs.set("include_archived", "true");
  const tail = qs.toString();
  return apiFetch<DonationsListResponse>(
    `/v1/donations${tail ? `?${tail}` : ""}`,
  );
}

export function createDonation(
  input: CreateDonationInput,
): Promise<Donation> {
  return apiFetch<Donation>("/v1/donations", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function deleteDonation(
  date: string,
  donationId: string,
): Promise<void> {
  return apiFetch<void>(`/v1/donations/${date}/${donationId}`, {
    method: "DELETE",
  });
}

export function listDafAccounts(): Promise<DafAccountsListResponse> {
  return apiFetch<DafAccountsListResponse>(`/v1/donations/daf-accounts`);
}

export function createDafAccount(
  input: CreateDafAccountInput,
): Promise<DafAccount> {
  return apiFetch<DafAccount>(`/v1/donations/daf-accounts`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function deleteDafAccount(dafAccountId: string): Promise<void> {
  return apiFetch<void>(`/v1/donations/daf-accounts/${dafAccountId}`, {
    method: "DELETE",
  });
}
